import React, { FC } from 'react';
import { observer } from 'mobx-react-lite';
import { PortalRouteItems } from '../PortalRouteItems';
import { useProjects, useTools, Projects } from '../../components';
import { CustomSpinner } from '@yakoffice/custom-spinner';
import { Routes, Route } from 'react-router-dom';
import { DocumentTitle } from '@yakoffice/shared-components';
import ProjectUsersIndex from './users/projectUsersIndex';
import ProjectToolsIndex from './tools/ProjectToolsIndex';

export const ProjectsIndex: FC = observer(() => {

    const loadToolsResult = useTools();
    const loadProjectsResult = useProjects();

    DocumentTitle('Projects - Portal');

    return !loadToolsResult.isLoaded || !loadProjectsResult.isLoaded
        ? <CustomSpinner spinnerText="Loading Projects and Tools..." />
        : <div>
            <Routes>
                <Route path={''} element={<Projects />} />
            </Routes>
            <Routes>
                <Route path={PortalRouteItems.ProjectIdParam}>
                    <Route path={PortalRouteItems.Users} element={<ProjectUsersIndex />} />
                    <Route path={PortalRouteItems.Tools} element={<ProjectToolsIndex />} />
                </Route>
            </Routes>
        </div>;
});

export default ProjectsIndex;

